import { closeBrackets } from '@codemirror/autocomplete';
import { defaultKeymap, history, historyKeymap, indentLess, insertNewline, redo } from '@codemirror/commands';
import { javascript } from '@codemirror/lang-javascript';
import { bracketMatching, foldGutter, indentUnit, syntaxHighlighting } from '@codemirror/language';
import { highlightSelectionMatches, searchKeymap } from '@codemirror/search';
import { EditorState } from '@codemirror/state';
import { highlightActiveLine, highlightSpecialChars, EditorView, keymap, lineNumbers }
	from '@codemirror/view';
import { classHighlighter } from '@lezer/highlight';

const editorView = initValue => new EditorView({
	parent: document.getElementById('editor-container'),
	state: EditorState.create({
		doc: initValue,
		extensions: [
			bracketMatching(),
			closeBrackets(),
			EditorState.tabSize.of('3'),
			EditorView.lineWrapping,
			EditorView.updateListener.of(view => {
				if(view.docChanged) {
					globalThis.bytebeat.sendData({ setFunction: view.state.doc.toString() });
				}
			}),
			foldGutter(),
			highlightActiveLine(),
			highlightSelectionMatches(),
			highlightSpecialChars(),
			history(),
			indentUnit.of('\t'),
			javascript(),
			keymap.of([
				{ key: 'Ctrl-Y', run: redo },
				{ key: 'Enter', run: insertNewline },
				{
					key: 'Tab',
					run: view => {
						const { state } = view;
						const { from, to } = state.selection.main;
						if (from === to) {
							return view.dispatch(state.replaceSelection('\t')) || true;
						}
						const fromLine = state.doc.lineAt(from).number;
						const toLine = state.doc.lineAt(to).number;
						const changes = [];
						for (let i = fromLine; i <= toLine; i++) {
							const line = state.doc.line(i);
							changes.push({ from: line.from, insert: '\t' });
						}
						return view.dispatch({ changes }) || true;
					},
					shift: indentLess
				},
				...historyKeymap,
				...searchKeymap,
				...defaultKeymap
			]),
			lineNumbers(),
			syntaxHighlighting(classHighlighter)
		]
	})
});

export class Editor {
	constructor() {
		this.container = null;
		this.defaultValue = '10*(t>>7|t|t>>6)+4*(t&t>>13|t>>6)';
		this.errorElem = null;
		this.view = null;
		this.loadingOverlay = null;
	}
	get value() {
		return this.view ? this.view.state.doc.toString() : this.defaultValue;
	}
	init() {
		document.getElementById('editor-default').remove();
		this.container = document.getElementById('editor-container');
		this.errorElem = document.getElementById('error');
		this.view = editorView(this.defaultValue);
		this.createLoadingOverlay();
	}
	createLoadingOverlay() {
		this.loadingOverlay = document.createElement('div');
		this.loadingOverlay.className = 'editor-loading hidden';
		this.loadingOverlay.innerHTML = `
			<svg class="loading-spinner"><use xlink:href="#symbol-wait"></use></svg>
			<span>Loading...</span>
		`;
		this.container.appendChild(this.loadingOverlay);
	}
	showLoading() {
		if(this.loadingOverlay) {
			this.loadingOverlay.classList.remove('hidden');
		}
	}
	hideLoading() {
		if(this.loadingOverlay) {
			this.loadingOverlay.classList.add('hidden');
		}
	}
	setValue(code) {
		if(!this.view) {
			return;
		}
		this.view.dispatch({
			changes: {
				from: 0,
				to: this.view.state.doc.toString().length,
				insert: code
			}
		});
	}
}
